import React, { useState, useEffect, Fragment } from "react";
import { useTransition, animated } from "react-spring";
import { ReactComponent as Cancel } from "common/assets/svg/cancel.svg";
import { ReactComponent as BackIcon } from "common/assets/svg/leftArrow.svg";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Showpassword } from "common/assets/svg/showPassword.svg";
import { ReactComponent as Hidepassword } from "common/assets/svg/hidePassword.svg";
import {
  clearOTPState,
  resetPasswordRequest,
  clearResetPassword,
} from "common/features/auth/AuthActions";
import { RootState } from "common/rootReducer";
import { validateField } from "common/utils/field-validator";
import "./styles.css";
import PasswordError from "components/PasswordError";

interface resetPasswordPromptProps {
  isOpen: boolean;
  visible: any;
}

const ResetPasswordPrompt = (props: resetPasswordPromptProps) => {
  const { isOpen, visible } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const transitions = useTransition(isOpen, null, {
    from: { transform: "translate3d(0,-15px,0)", opacity: 0.4 },
    enter: { transform: "translate3d(0,0px,0)", opacity: 1 },
    leave: { transform: "translate3d(0,-15px,0)", opacity: 0 },
    unique: true,
  });

  const ColoredLine = ({ color }: any) => (
    <hr
      style={{
        color,
        backgroundColor: "#E0E0E0",
        height: 1,
        width: "100%",
        marginTop: 10,
        marginBottom: 20,
      }}
    />
  );

  const [newPassword, setNewPassword] = useState("");
  const [isNewPasswordShown, setIsNewPasswordShown] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [isConfirmPasswordShown, setIsConfirmPasswordShown] = useState(false);

  const { handleSubmit, register, errors, watch, formState } = useForm();

  const { isSubmitted } = formState;
  const userId = useSelector(
    (state: RootState) => state.auth.resetPasswordUser?.mobilePhone
  );

  const resetSuccess = useSelector(
    (state: RootState) => state.auth.resetPasswordSuccess
  );
  const resetInitiateSuccess = useSelector(
    (state: RootState) => state.auth.resetPasswordInitiateSuccess
  );
  const resetPasswordLoading = useSelector(
    (state: RootState) => state.auth.resetPasswordLoading
  );

  const reserPassworderrorMessage = useSelector(
    (state: RootState) => state.auth.resetPasswordMessage
  );

  useEffect(() => {
    if (resetSuccess && isSubmitted) {
      dispatch(clearOTPState());
      dispatch(clearResetPassword());
      // history.push({
      //   pathname: "/resetPassword/success",
      //   state: {
      //     newPassword,
      //   },
      // });
      visible(true);
    }
  }, [resetSuccess]);

  const onSubmit = () => {
    dispatch(
      resetPasswordRequest({
        mobilePhone: userId,
        sendOtp: 0,
        password: newPassword,
      })
    );
  };

  return (
    <Fragment>
      <Fragment>
        {isOpen ? <div id="modal-background "></div> : null}
        {transitions.map(({ item, key, props }) =>
          item ? (
            <animated.div className="CPWrapper">
              <animated.div
                className="CPContainer reset-CPContainer"
                key={key}
                style={props}
              >
                <div className="reset-password">
                  <div className="reset-password-header">
                    <div className="header-container">
                      <BackIcon onClick={() => visible(true)} />
                      <span className="title-texts">RESET PASSWORD</span>
                      <Cancel
                        onClick={() => visible(true)}
                        className="cancelDes"
                      />
                    </div>
                    <div className="ColoredLine">
                      <ColoredLine color="#DCDCDC" />
                    </div>
                  </div>
                  <div className="contentContainer">
                    <form id="password-input" onSubmit={handleSubmit(onSubmit)}>
                      <div id="reset-text-box-container">
                        New Password
                        <div id="reset-text-box">
                          <input
                            type={isNewPasswordShown ? "text" : "password"}
                            name="newPassword"
                            placeholder="Enter password"
                            // ref={register({
                            //   required: "Required",
                            //   pattern: {
                            //     value: /[^A-Za-z ]/g,
                            //     message: "invalid password",
                            //   },
                            // })}
                            ref={register({
                              required: "Password is required",
                              minLength: {
                                value: 8,
                                message: "Password must be more than 8 characters long",
                              },
                              pattern: {
                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]{8,}$/,
                                message: "Password must be alphanumeric, contain at least one uppercase letter, one special character and must not have spaces",
                              },
                            })}
                            // ref={register(
                            //   validateField("newPassword")
                            //     .isRequired()
                            //     .isValidPassword().Rules
                            // )}
                            // value={newPassword}
                            onChange={(text) => {
                              setNewPassword(text.target.value);
                            }}
                            // value={newPassword}
                          />
                          {isNewPasswordShown ? (
                            <Hidepassword
                              className="hidePasswordSVG"
                              onClick={() => {
                                setIsNewPasswordShown(!isNewPasswordShown);
                              }}
                            />
                          ) : (
                            <Showpassword
                              className="showPasswordSVG"
                              onClick={() => {
                                setIsNewPasswordShown(!isNewPasswordShown);
                              }}
                            />
                          )}
                        </div>
                        <span className="sign-up-form-error-msg">
                          {errors.newPassword &&
                            errors.newPassword.type === "required" && (
                              <span>Password Required</span>
                            )}
                          {errors.newPassword &&
                            errors.newPassword.type === "minLength" && (
                              <span>{errors.newPassword.message}</span>
                            )}
                          {errors.newPassword &&
                            errors.newPassword.type === "pattern" && (
                              <PasswordError/>
                            )}
                        </span>
                      </div>
                      <div
                        id="reset-text-box-container"
                        style={{ marginTop: "1.275rem" }}
                      >
                        Confirm Password
                        <div id="reset-text-box">
                          <input
                            type={isConfirmPasswordShown ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Re Enter password"
                            ref={register(
                              validateField("confirmPassword")
                                .isRequired()
                                .matchesField(
                                  watch,
                                  "newPassword",
                                  "",
                                  "Password does not match"
                                ).Rules
                            )}
                            onChange={(text) => {
                              setConfirmPassword(text.target.value);
                            }}
                          />

                          {isConfirmPasswordShown ? (
                            <Hidepassword
                              className="hidePasswordSVG"
                              onClick={() => {
                                setIsConfirmPasswordShown(
                                  !isConfirmPasswordShown
                                );
                              }}
                            />
                          ) : (
                            <Showpassword
                              className="showPasswordSVG"
                              onClick={() => {
                                setIsConfirmPasswordShown(
                                  !isConfirmPasswordShown
                                );
                              }}
                            />
                          )}
                        </div>
                        <span className="sign-up-form-error-msg">
                          {errors.confirmPassword &&
                            errors.confirmPassword.type == "required" && (
                              <span>Password Required</span>
                            )}
                          {errors.confirmPassword &&
                            errors.confirmPassword.type == "validate" && (
                              <span>{errors.confirmPassword.message}</span>
                            )}
                        </span>
                      </div>
                      <button id="done-button" type="submit">
                        {resetPasswordLoading ? "Updating" : "Done"}
                      </button>
                    </form>
                  </div>
                </div>
              </animated.div>
            </animated.div>
          ) : null
        )}
      </Fragment>
    </Fragment>
  );
};

export default ResetPasswordPrompt;
